import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27049f5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content_list_item" }
const _hoisted_2 = { class: "content_list_item_top" }
const _hoisted_3 = { class: "content_list_item_top_left" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "type backgreen"
}
const _hoisted_6 = {
  key: 2,
  class: "type backyellow"
}
const _hoisted_7 = { class: "content_list_item_top_right" }
const _hoisted_8 = {
  key: 0,
  class: "yellow"
}
const _hoisted_9 = {
  key: 1,
  class: "green"
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  key: 3,
  class: "purple"
}
const _hoisted_12 = { key: 4 }
const _hoisted_13 = { key: 5 }
const _hoisted_14 = { key: 6 }
const _hoisted_15 = {
  key: 7,
  class: "green"
}
const _hoisted_16 = { class: "content_list_item_content" }
const _hoisted_17 = { class: "content_list_item_content_item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "物料编码：", -1))
const _hoisted_19 = {
  key: 0,
  class: "content_list_item_content_item_nr"
}
const _hoisted_20 = { class: "content_list_item_content_item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "计划开工：", -1))
const _hoisted_22 = { class: "content_list_item_content_item_nr" }
const _hoisted_23 = { class: "content_list_item_content_item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "生产批次：", -1))
const _hoisted_25 = { class: "content_list_item_content_item_nr" }
const _hoisted_26 = { class: "content_list_item_content_item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "计划数量：", -1))
const _hoisted_28 = {
  key: 0,
  class: "content_list_item_content_item_nr"
}
const _hoisted_29 = { class: "content_list_item_content_item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "生产设备：", -1))
const _hoisted_31 = {
  key: 0,
  class: "content_list_item_content_item_nr"
}
const _hoisted_32 = { class: "content_list_item_content_item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "生产人员：", -1))
const _hoisted_34 = { class: "content_list_item_content_item_nrs" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_36 = { class: "content_list_item_yq_left" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "工艺要求：", -1))

import { ref, watch } from 'vue'
    import { getListByWorkOrderId } from '@/apis/WorkOrderAPI'
    import { useRouter } from "vue-router"

    
export default /*#__PURE__*/_defineComponent({
  props: {
        info: {
            type: Object,
            required: true
        }
    },
  setup(__props) {

const props = __props

    let loading = ref<boolean>(true)
    const router = useRouter()
    let tips = ref<string>('')  // 工艺要求

    // 详情数据
    

    // 根据工单id查工艺卡
    const getListByWorkOrderIdInfo = () => {
        getListByWorkOrderId({ workOrderId: props.info.id })
            .then(res => {
                if (res.code === 200) {
                    tips.value = res.data.tips
                }
            })
            .finally(() => {
                loading.value = false
            })
    }

    // 跳转查工艺
    const jumpGY = () => {
        router.push({ name: 'checkTheProcess', query: { id: props.info.id } })
    }

    watch(() => props.info, async (news) => {
        if (JSON.stringify(news) !== "{}") {
            await getListByWorkOrderIdInfo()
        }
    }, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_van_skeleton = _resolveComponent("van-skeleton")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_skeleton, {
      loading: _unref(loading),
      title: "",
      row: 8,
      "row-width": ['100%', '100%', '100%', '100%', '100%', '100%']
    }, null, 8, ["loading"]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (props.info.mmodel)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(props.info.mmodel.name) + " | " + _toDisplayString(props.info.procedureName), 1))
          : _createCommentVNode("", true),
        (props.info.type === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "正常"))
          : _createCommentVNode("", true),
        (props.info.type === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, "返工返修"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (props.info.status === 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, "已创建"))
          : _createCommentVNode("", true),
        (props.info.status === 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "已备料"))
          : _createCommentVNode("", true),
        (props.info.status === 2)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "已完工检"))
          : _createCommentVNode("", true),
        (props.info.status === 3)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "已检验"))
          : _createCommentVNode("", true),
        (props.info.status === 4)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, "已报工"))
          : _createCommentVNode("", true),
        (props.info.status === 5)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "已入库"))
          : _createCommentVNode("", true),
        (props.info.status === 6)
          ? (_openBlock(), _createElementBlock("span", _hoisted_14, "已取消"))
          : _createCommentVNode("", true),
        (props.info.status === 7)
          ? (_openBlock(), _createElementBlock("span", _hoisted_15, "进行中"))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, !_unref(loading)]
    ]),
    _withDirectives(_createElementVNode("div", { class: "content_list_item_code" }, "工单编号：" + _toDisplayString(props.info.code), 513), [
      [_vShow, !_unref(loading)]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        (props.info.mmodel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(props.info.mmodel.code), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, _toDisplayString(props.info.planDate), 1)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, _toDisplayString(props.info.batch), 1)
      ]),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        (props.info.umodel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(props.info.planNum) + _toDisplayString(props.info.umodel.name), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        (props.info.pgmodel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(props.info.pgmodel.code) + " - " + _toDisplayString(props.info.pgmodel.name), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.info.proUserList, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              _createTextVNode(_toDisplayString(item.proUserDepartName), 1),
              (index !== props.info.proUserList.length - 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_35
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ])
    ], 512), [
      [_vShow, !_unref(loading)]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "content_list_item_yq",
      onClick: jumpGY
    }, [
      _createElementVNode("div", _hoisted_36, [
        _hoisted_37,
        _createElementVNode("span", null, _toDisplayString(_unref(tips)), 1)
      ]),
      _createVNode(_component_van_icon, {
        name: "arrow",
        color: "#666666",
        size: "16"
      })
    ], 512), [
      [_vShow, !_unref(loading) && _unref(tips)]
    ])
  ]))
}
}

})